// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".app-footer-menu-items{list-style:none;padding:0}.app-footer-menu-item__link{align-items:center;display:flex;height:var(--list-item-height)}@media(min-width:1024px){.app-footer-menu-item__link{height:-moz-fit-content;height:fit-content;margin-bottom:var(--spacing-default)}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
